export enum MortgageCalculationType {
    move = "move",
    new = "new",
}

export interface IMortgageConfiguration {
    calculationTypes: Array<MortgageCalculationType>;
    amortizationRequirementsAsDefault?: boolean;
}
